export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updateDate: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  longDescription: string;
  category: string;
  categorySlug: string;
  tags: string[];
  rating: number;
  views: number;
  status: '连载中' | '已完结';
  totalChapters: number;
  updateDate: string;
  chapters: ComicChapter[];
  isNew: boolean;
  isHot: boolean;
  isRecommended: boolean;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '恋爱', slug: 'romance' },
  { name: '奇幻', slug: 'fantasy' },
  { name: '动作', slug: 'action' },
  { name: '搞笑', slug: 'comedy' },
  { name: '悬疑', slug: 'thriller' },
  { name: '日常', slug: 'slice-of-life' },
  { name: '剧情', slug: 'drama' },
  { name: 'BL', slug: 'bl' },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '恋爱革命',
    author: '李多惠',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20cover%20art%20style%2C%20young%20couple%20in%20school%20uniform%20under%20cherry%20blossom%20tree%2C%20soft%20pink%20and%20white%20color%20palette%2C%20clean%20minimalist%20composition%2C%20manhwa%20illustration%20with%20gentle%20lighting%2C%20light%20beige%20background%2C%20editorial%20quality%2C%20professional%20digital%20art%2C%20subtle%20warm%20atmosphere&width=400&height=560&seq=comic-cover-1&orientation=portrait',
    description: '平凡的女高中生意外邂逅校园男神，一段甜蜜又曲折的恋爱故事就此展开。',
    longDescription: '普通的女高中生韩素希，原本过着平凡无奇的校园生活。一天，她偶然在图书馆遇到了全校公认的校草——朴志勋。本以为只是一次普通的偶遇，没想到命运的齿轮开始转动。从陌生到熟悉，从误会到心动，两个性格迥异的年轻人，在青春的校园里谱写了一段令人心动的恋爱故事。然而，爱情的道路从来不会一帆风顺，家庭的阻碍、朋友的误解、暗恋者的出现……种种考验接踵而至。他们能否守护这份来之不易的感情？一场轰轰烈烈的恋爱革命，即将开始！',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['校园', '青春', '甜宠', '恋爱'],
    rating: 9.6,
    views: 1280000,
    status: '连载中',
    totalChapters: 86,
    updateDate: '2026-08-03',
    chapters: Array.from({ length: 86 }, (_, i) => ({
      id: `comic-1-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-03',
    })),
    isNew: false,
    isHot: true,
    isRecommended: true,
  },
  {
    id: 'comic-2',
    title: '剑与魔法',
    author: '金泰亨',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%2C%20warrior%20holding%20glowing%20sword%20in%20medieval%20fantasy%20setting%2C%20dramatic%20lighting%20with%20golden%20and%20emerald%20tones%2C%20epic%20adventure%20atmosphere%2C%20clean%20illustration%20style%2C%20light%20cream%20background%2C%20digital%20art%20masterpiece%2C%20professional%20composition&width=400&height=560&seq=comic-cover-2&orientation=portrait',
    description: '在剑与魔法的世界中，少年剑士踏上寻找传说之剑的冒险旅程。',
    longDescription: '在一个被魔法与剑统治的奇幻世界里，少年亚瑟从小在边境村庄长大。一日，村庄遭到黑暗势力的袭击，亚瑟目睹了传说中的圣剑出现在他面前。为了寻找真相并拯救世界，亚瑟踏上了冒险之旅。途中他结识了精灵法师莉娜、矮人战士巴鲁克和神秘的刺客影。他们穿越幽暗森林、攀登极寒雪山、潜入古老遗迹，面对巨龙、亡灵军团和背叛者的阴谋。这是一段关于勇气、友情与成长的史诗故事。',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['冒险', '魔法', '剑士', '史诗'],
    rating: 9.4,
    views: 960000,
    status: '连载中',
    totalChapters: 72,
    updateDate: '2026-08-02',
    chapters: Array.from({ length: 72 }, (_, i) => ({
      id: `comic-2-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-02',
    })),
    isNew: false,
    isHot: true,
    isRecommended: true,
  },
  {
    id: 'comic-3',
    title: '暗夜追踪者',
    author: '朴智星',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20webtoon%20cover%2C%20detective%20in%20trench%20coat%20standing%20in%20rainy%20alley%20at%20night%2C%20noir%20atmosphere%20with%20deep%20shadows%2C%20monochrome%20with%20red%20accent%2C%20mysterious%20and%20tense%20mood%2C%20clean%20illustration%2C%20light%20background%20edges%2C%20professional%20manhwa%20art&width=400&height=560&seq=comic-cover-3&orientation=portrait',
    description: '连环杀人案背后的惊天秘密，一名警探与犯罪心理学家的联手追踪。',
    longDescription: '首尔连续发生多起离奇命案，受害者之间看似毫无关联，但犯罪现场都留有一个神秘的符号。刑警李俊昊接手此案后，发现这背后隐藏着一个横跨二十年的惊天阴谋。在犯罪心理学专家金瑞妍的协助下，两人一步步逼近真相。然而，越是深入调查，危险就越近。当他们发现凶手的真正目标时，自己已经成了猎物的猎物。一部扣人心弦的悬疑推理大作，每一页都让人屏住呼吸。',
    category: '悬疑',
    categorySlug: 'thriller',
    tags: ['悬疑', '推理', '犯罪', '心理'],
    rating: 9.7,
    views: 850000,
    status: '连载中',
    totalChapters: 54,
    updateDate: '2026-08-04',
    chapters: Array.from({ length: 54 }, (_, i) => ({
      id: `comic-3-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-04',
    })),
    isNew: true,
    isHot: true,
    isRecommended: true,
  },
  {
    id: 'comic-4',
    title: '办公室罗曼史',
    author: '郑秀妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20office%20romance%20manhwa%20cover%2C%20stylish%20woman%20and%20man%20in%20modern%20office%20setting%2C%20warm%20ambient%20lighting%2C%20elegant%20character%20design%2C%20soft%20coral%20and%20cream%20color%20scheme%2C%20professional%20atmosphere%2C%20clean%20digital%20illustration%2C%20minimalist%20aesthetic%2C%20romantic%20subtle%20tension&width=400&height=560&seq=comic-cover-4&orientation=portrait',
    description: '职场新人遇上霸道总裁，办公室里的秘密恋情暗潮涌动。',
    longDescription: '刚从大学毕业的苏敏雅进入了一家顶级广告公司。本以为可以在职场大展拳脚，没想到第一天就惹上了公司最年轻有为的本部长——姜泰浩。冷酷、完美主义、不近人情，这就是姜泰浩给所有人的印象。但苏敏雅渐渐发现，这个冷面上司的背后，藏着一个不为人知的温柔灵魂。当工作与感情交织，办公室里的秘密恋情悄然绽放。然而，职场规则和外界眼光成了他们之间最大的阻碍。这段办公室罗曼史，能否开花结果？',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['职场', '总裁', '恋爱', '甜蜜'],
    rating: 9.3,
    views: 720000,
    status: '连载中',
    totalChapters: 48,
    updateDate: '2026-08-01',
    chapters: Array.from({ length: 48 }, (_, i) => ({
      id: `comic-4-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-01',
    })),
    isNew: false,
    isHot: true,
    isRecommended: false,
  },
  {
    id: 'comic-5',
    title: '搞笑一家人',
    author: '张贤宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20family%20manhwa%20cover%2C%20chaotic%20family%20of%20five%20with%20exaggerated%20funny%20expressions%2C%20bright%20and%20vibrant%20colors%2C%20cartoonish%20style%2C%20warm%20yellow%20and%20orange%20palette%2C%20playful%20atmosphere%2C%20clean%20illustration%2C%20light%20background%2C%20humorous%20digital%20art&width=400&height=560&seq=comic-cover-5&orientation=portrait',
    description: '一家五口的爆笑日常生活，每个家庭成员都有不为人知的搞笑一面。',
    longDescription: '张家是一个普通又不普通的五口之家。爸爸是个怕老婆的公司职员，妈妈是家里的绝对统治者，大儿子是沉迷游戏的宅男，二女儿是追星狂热粉，小儿子则是全家的开心果。从柴米油盐到鸡毛蒜皮，每一个日常瞬间都被放大成爆笑故事。邻居家的八卦、亲戚间的较量、学校里的趣事……生活中的点点滴滴，都在这部漫画里变成了让人捧腹大笑的素材。准备好了吗？这一家人将让你笑到停不下来！',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['搞笑', '家庭', '日常', '爆笑'],
    rating: 9.5,
    views: 1500000,
    status: '连载中',
    totalChapters: 120,
    updateDate: '2026-08-04',
    chapters: Array.from({ length: 120 }, (_, i) => ({
      id: `comic-5-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-04',
    })),
    isNew: true,
    isHot: true,
    isRecommended: true,
  },
  {
    id: 'comic-6',
    title: '仙界重生',
    author: '柳在赫',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20cultivation%20fantasy%20manhwa%20cover%2C%20immortal%20warrior%20with%20flowing%20robes%20in%20celestial%20realm%2C%20divine%20golden%20light%20and%20clouds%2C%20traditional%20oriental%20elements%2C%20elegant%20and%20majestic%2C%20soft%20ivory%20background%2C%20clean%20illustration%2C%20ethereal%20atmosphere%2C%20professional%20digital%20art&width=400&height=560&seq=comic-cover-6&orientation=portrait',
    description: '一代仙帝陨落重生，回到少年时代重新修炼，逆天改命的爽文漫画。',
    longDescription: '天玄大陆最强的仙帝林逸，在渡劫飞升时遭到挚友背叛，含恨陨落。然而命运给了他第二次机会——他重生回到了十七岁那年。带着前世的记忆和无上功法，林逸重新踏上修炼之路。这一次，他不会再犯同样的错误。昔日踩过他的人，必将百倍奉还；曾经守护他的人，这一次换他来守护。从被所有人看不起的废物，到睥睨天下的绝世强者，林逸的逆袭之路，才刚刚开始！',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['修仙', '重生', '逆袭', '爽文'],
    rating: 9.8,
    views: 2100000,
    status: '连载中',
    totalChapters: 156,
    updateDate: '2026-08-04',
    chapters: Array.from({ length: 156 }, (_, i) => ({
      id: `comic-6-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-04',
    })),
    isNew: true,
    isHot: true,
    isRecommended: true,
  },
  {
    id: 'comic-7',
    title: '猫的报恩',
    author: '崔美英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20manhwa%20cover%2C%20young%20woman%20with%20cute%20orange%20cat%20in%20cozy%20apartment%2C%20warm%20sunlight%20through%20window%2C%20soft%20pastel%20colors%2C%20peaceful%20and%20healing%20atmosphere%2C%20clean%20illustration%2C%20minimalist%20design%2C%20light%20beige%20background%2C%20gentle%20digital%20art&width=400&height=560&seq=comic-cover-7&orientation=portrait',
    description: '孤独女孩与神奇猫咪的温暖相遇，一部治愈心灵的日常漫画。',
    longDescription: '独自在首尔打拼的插画师姜瑞希，生活单调而孤独。某个雨夜，她在回家路上救了一只受伤的橘猫。没想到这只猫不仅通人性，还总能用它的方式温暖她的心。从它来了之后，生活开始悄悄发生变化——工作上遇到了转机，身边的朋友变多了，甚至连爱情也悄然而至。也许，这就是猫的报恩吧。一部充满温暖与治愈的日常漫画，献给每一个在城市里独自奋斗的你。',
    category: '日常',
    categorySlug: 'slice-of-life',
    tags: ['治愈', '猫咪', '日常', '温馨'],
    rating: 9.2,
    views: 560000,
    status: '已完结',
    totalChapters: 60,
    updateDate: '2026-07-15',
    chapters: Array.from({ length: 60 }, (_, i) => ({
      id: `comic-7-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-07-15',
    })),
    isNew: false,
    isHot: false,
    isRecommended: true,
  },
  {
    id: 'comic-8',
    title: '格斗天王',
    author: '安哲秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20fighting%20manhwa%20cover%2C%20powerful%20fighter%20in%20boxing%20stance%20with%20determined%20expression%2C%20dynamic%20motion%20lines%2C%20red%20and%20black%20intense%20color%20scheme%2C%20underground%20arena%20vibe%2C%20clean%20illustration%2C%20dramatic%20lighting%2C%20professional%20digital%20art&width=400&height=560&seq=comic-cover-8&orientation=portrait',
    description: '街头少年一步步打进职业格斗赛场，热血与荣耀的巅峰对决。',
    longDescription: '金武烈是个在街头长大的孤儿，打架是他的生存本能。一次偶然的机会，他被退役格斗冠军崔教练发掘，进入了职业格斗的世界。从街头斗殴到职业赛场，从野路子到专业选手，金武烈用自己的拳头打出了一条血路。但职业格斗的世界远比街头残酷——强大的对手、背后的资本博弈、媒体的舆论压力……每一战都是生死考验。这不仅是一部格斗漫画，更是一个关于梦想、坚持和荣耀的热血故事。',
    category: '动作',
    categorySlug: 'action',
    tags: ['格斗', '热血', '竞技', '成长'],
    rating: 9.1,
    views: 680000,
    status: '连载中',
    totalChapters: 90,
    updateDate: '2026-08-03',
    chapters: Array.from({ length: 90 }, (_, i) => ({
      id: `comic-8-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-03',
    })),
    isNew: false,
    isHot: false,
    isRecommended: false,
  },
  {
    id: 'comic-9',
    title: '花之旋律',
    author: '尹智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20music%20romance%20manhwa%20cover%2C%20beautiful%20female%20pianist%20playing%20grand%20piano%20on%20stage%2C%20spotlight%20and%20floating%20flower%20petals%2C%20elegant%20and%20romantic%20mood%2C%20soft%20pink%20and%20gold%20tones%2C%20clean%20illustration%2C%20delicate%20details%2C%20light%20background&width=400&height=560&seq=comic-cover-9&orientation=portrait',
    description: '音乐天才少女与失意指挥家，在音符中奏响的动人恋曲。',
    longDescription: '年仅十九岁的钢琴天才韩智雅，在国际大赛上一鸣惊人。但她内心深处，总觉得自己的音乐缺少了什么。直到遇见了那位曾经名震天下、如今却默默无闻的指挥家李善宇。他用独特的方式引导她理解音乐的本质，而她也让这位失意的音乐人重新找回了最初的热情。两个灵魂在音乐中相遇、碰撞、融合。然而，当过去的秘密浮出水面，他们的关系能否承受得住考验？一段关于音乐、爱情与救赎的动人故事。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['音乐', '恋爱', '成长', '艺术'],
    rating: 9.6,
    views: 490000,
    status: '连载中',
    totalChapters: 42,
    updateDate: '2026-08-01',
    chapters: Array.from({ length: 42 }, (_, i) => ({
      id: `comic-9-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-01',
    })),
    isNew: false,
    isHot: false,
    isRecommended: true,
  },
  {
    id: 'comic-10',
    title: '星之彼端',
    author: '文俊辉',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%2C%20two%20handsome%20young%20men%20looking%20at%20starry%20sky%2C%20tender%20and%20romantic%20atmosphere%2C%20deep%20blue%20and%20silver%20color%20palette%2C%20elegant%20character%20design%2C%20clean%20illustration%2C%20dreamy%20night%20mood%2C%20professional%20digital%20art%2C%20subtle%20emotional%20tension&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '天文系学生与神秘转校生之间，跨越星辰的浪漫故事。',
    longDescription: '天文系大三学生金星河，生活里只有星星和望远镜。直到有一天，一个叫韩星海的神秘转校生闯入他的世界。韩星海似乎对天文有着超乎寻常的了解，但他又总是在回避某些问题。两人因为一次天文观测而逐渐走近，在星空下分享彼此的故事。可是韩星海的身上藏着一个不能说的秘密，这个秘密可能会彻底改变两人的关系。在星辰的见证下，一段跨越命运的爱情悄然绽放。',
    category: 'BL',
    categorySlug: 'bl',
    tags: ['BL', '校园', '浪漫', '星空'],
    rating: 9.0,
    views: 380000,
    status: '连载中',
    totalChapters: 36,
    updateDate: '2026-08-04',
    chapters: Array.from({ length: 36 }, (_, i) => ({
      id: `comic-10-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-04',
    })),
    isNew: true,
    isHot: false,
    isRecommended: false,
  },
  {
    id: 'comic-11',
    title: '末世纪元',
    author: '权相佑',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20post%20apocalyptic%20action%20manhwa%20cover%2C%20survivor%20with%20weapon%20in%20ruined%20cityscape%2C%20dramatic%20sunset%20lighting%2C%20orange%20and%20gray%20color%20scheme%2C%20tense%20survival%20atmosphere%2C%20clean%20illustration%2C%20professional%20digital%20art%2C%20epic%20landscape&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '末日降临后的生存之战，人类在废墟中寻找最后的希望。',
    longDescription: '一场突如其来的病毒席卷全球，大部分人类变成了可怕的变异体。幸存者姜赫带领着一小队人马，在首尔的废墟中艰难求生。他们不仅要面对变异体的威胁，还要提防其他幸存者群体的掠夺。在绝望的世界里，人性的光辉与黑暗同时被放大。当姜赫得知还有一个被称为"伊甸园"的安全区时，他决定带领大家踏上寻找希望的旅程。然而，旅途中等待他们的，是远比变异体更加可怕的真相。',
    category: '动作',
    categorySlug: 'action',
    tags: ['末日', '生存', '热血', '冒险'],
    rating: 9.4,
    views: 920000,
    status: '连载中',
    totalChapters: 64,
    updateDate: '2026-08-02',
    chapters: Array.from({ length: 64 }, (_, i) => ({
      id: `comic-11-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-02',
    })),
    isNew: false,
    isHot: true,
    isRecommended: false,
  },
  {
    id: 'comic-12',
    title: '美食情缘',
    author: '韩素希',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20food%20romance%20manhwa%20cover%2C%20female%20chef%20cooking%20in%20warm%20kitchen%2C%20steaming%20delicious%20food%2C%20cozy%20and%20inviting%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20clean%20illustration%2C%20mouthwatering%20details%2C%20professional%20digital%20art&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '米其林主厨与美食博主的浪漫邂逅，用料理传递心意的甜蜜故事。',
    longDescription: '姜秀妍是首尔最年轻的米其林一星主厨，她的生活只有厨房和料理。直到一个叫朴世俊的美食博主来餐厅探访，两人的命运开始交织。朴世俊对食物有着天生的敏感，而姜秀妍对料理的执着也深深吸引了他。两人因美食而结缘，又在料理的过程中慢慢靠近彼此。从韩式烤肉到法式甜点，每一道菜都是他们感情的见证。但姜秀妍的过去和朴世俊的秘密，成了横亘在两人之间的鸿沟。这道爱情料理，能否圆满装盘？',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['美食', '恋爱', '料理', '温暖'],
    rating: 9.5,
    views: 640000,
    status: '连载中',
    totalChapters: 38,
    updateDate: '2026-08-03',
    chapters: Array.from({ length: 38 }, (_, i) => ({
      id: `comic-12-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-03',
    })),
    isNew: false,
    isHot: false,
    isRecommended: true,
  },
  {
    id: 'comic-13',
    title: '迷雾之城',
    author: '宋智孝',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20thriller%20manhwa%20cover%2C%20woman%20in%20foggy%20city%20street%20with%20mysterious%20silhouette%20behind%2C%20dark%20teal%20and%20gray%20color%20palette%2C%20suspenseful%20noir%20atmosphere%2C%20clean%20illustration%2C%20eerie%20mood%2C%20professional%20digital%20art&width=400&height=560&seq=comic-cover-13&orientation=portrait',
    description: '一个永远被迷雾笼罩的城市，每个居民都藏着不为人知的秘密。',
    longDescription: '迷雾之城是一座被永恒浓雾笼罩的都市。在这里，阳光是奢侈品，而秘密则是每个人生活的必需品。新来的菜鸟记者林素媛被分配调查一起失踪案，却在调查中发现了这座城市底下隐藏的巨大秘密网。政府、财阀、地下组织……各方势力在浓雾中暗流涌动。每个人都说着谎言，却又藏着真相。林素媛必须在谎言与真相的迷宫中找到出路，否则她将永远困在这座迷雾之城中。',
    category: '悬疑',
    categorySlug: 'thriller',
    tags: ['悬疑', '都市', '阴谋', '调查'],
    rating: 9.3,
    views: 710000,
    status: '连载中',
    totalChapters: 46,
    updateDate: '2026-08-04',
    chapters: Array.from({ length: 46 }, (_, i) => ({
      id: `comic-13-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-04',
    })),
    isNew: true,
    isHot: false,
    isRecommended: false,
  },
  {
    id: 'comic-14',
    title: '我的室友是吸血鬼',
    author: '罗渽民',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20supernatural%20comedy%20manhwa%20cover%2C%20vampire%20roommate%20in%20modern%20apartment%20with%20comic%20expression%2C%20playful%20and%20humorous%20style%2C%20dark%20purple%20and%20bright%20contrast%2C%20clean%20illustration%2C%20fun%20atmosphere%2C%20professional%20digital%20art&width=400&height=560&seq=comic-cover-14&orientation=portrait',
    description: '普通大学生和吸血鬼室友的同居爆笑日常，超自然与现实的碰撞。',
    longDescription: '大学生曹恩宇为了省房租，找了一个新室友。新室友李赫看起来又帅又绅士，但有个小问题——他是个已经活了三百年的吸血鬼。从此，恩宇的生活彻底乱套了。冰箱里总是塞满血袋，快递员来送活鸡，半夜还有狼人和女巫来串门。更要命的是，吸血鬼猎人组织盯上了李赫，而恩宇这个普通人类也被卷入了超自然的混乱之中。爆笑又温馨的同居生活，每一页都让人笑到流泪。',
    category: '搞笑',
    categorySlug: 'comedy',
    tags: ['搞笑', '超自然', '吸血鬼', '同居'],
    rating: 9.4,
    views: 880000,
    status: '连载中',
    totalChapters: 58,
    updateDate: '2026-08-01',
    chapters: Array.from({ length: 58 }, (_, i) => ({
      id: `comic-14-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-01',
    })),
    isNew: false,
    isHot: false,
    isRecommended: false,
  },
  {
    id: 'comic-15',
    title: '画中仙',
    author: '裴秀智',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20historical%20fantasy%20manhwa%20cover%2C%20beautiful%20woman%20in%20traditional%20hanbok%20emerging%20from%20ancient%20painting%2C%20ethereal%20and%20mystical%20atmosphere%2C%20soft%20jade%20green%20and%20gold%20tones%2C%20clean%20illustration%2C%20elegant%20traditional%20aesthetic%2C%20professional%20digital%20art&width=400&height=560&seq=comic-cover-15&orientation=portrait',
    description: '一幅古画中的仙女来到现代，与美术修复师的奇幻之恋。',
    longDescription: '美术修复师徐浩然接到了一个神秘的任务——修复一幅来自朝鲜时代的古画。画中描绘的是一位绝世美人在花园中起舞。然而在一次意外中，画中女子竟然活了过来，来到了现代社会。她叫素月，是画中封印了三百年的灵魂。初到现代的她闹出了无数笑话，也渐渐对这个全新的世界产生了好奇。而徐浩然在与她的相处中，不知不觉动了真情。但古画的封印有时间限制，素月终将回归画中。在时间耗尽之前，他们的爱情能否打破诅咒？',
    category: '奇幻',
    categorySlug: 'fantasy',
    tags: ['古风', '奇幻', '穿越', '恋爱'],
    rating: 9.7,
    views: 1050000,
    status: '已完结',
    totalChapters: 80,
    updateDate: '2026-06-20',
    chapters: Array.from({ length: 80 }, (_, i) => ({
      id: `comic-15-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-06-20',
    })),
    isNew: false,
    isHot: true,
    isRecommended: true,
  },
  {
    id: 'comic-16',
    title: '热血高校',
    author: '黄光熙',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20school%20action%20manhwa%20cover%2C%20group%20of%20high%20school%20students%20in%20uniform%20with%20determined%20looks%2C%20dynamic%20pose%2C%20vibrant%20youth%20energy%2C%20red%20and%20navy%20color%20scheme%2C%20clean%20illustration%2C%20inspiring%20atmosphere%2C%20professional%20digital%20art&width=400&height=560&seq=comic-cover-16&orientation=portrait',
    description: '一所以打架闻名的学校，一群热血少年为了梦想而战。',
    longDescription: '正义高中是全韩国最乱的高中，每天都有打架事件。转学生姜太贤来到这里的第一天，就卷入了校园帮派的纷争中。但他和其他人不一样，他不是来打架的，而是想改变这所学校。在结识了一群志同道合的朋友后，他们组建了正义联盟，决心用热血和行动改变校园不良风气。面对校内的恶势力、外校的挑衅，他们用拳头和信念捍卫正义。这部漫画充满青春的热血与激情，让人看了热血沸腾！',
    category: '动作',
    categorySlug: 'action',
    tags: ['校园', '热血', '友情', '打架'],
    rating: 9.0,
    views: 790000,
    status: '连载中',
    totalChapters: 74,
    updateDate: '2026-08-03',
    chapters: Array.from({ length: 74 }, (_, i) => ({
      id: `comic-16-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-03',
    })),
    isNew: false,
    isHot: false,
    isRecommended: false,
  },
  {
    id: 'comic-17',
    title: '咖啡与诗',
    author: '林允儿',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20literary%20slice%20of%20life%20manhwa%20cover%2C%20bookstore%20cafe%20with%20warm%20lighting%2C%20young%20woman%20reading%20with%20coffee%20cup%2C%20cozy%20and%20peaceful%20mood%2C%20soft%20brown%20and%20cream%20tones%2C%20clean%20illustration%2C%20quiet%20atmosphere%2C%20professional%20digital%20art&width=400&height=560&seq=comic-cover-17&orientation=portrait',
    description: '一家街角咖啡书店里的温暖故事，每个客人都带着自己的心事。',
    longDescription: '在首尔一条安静的巷子里，有一家叫"咖啡与诗"的小店。店主金书妍是个热爱文学的女孩，她相信每一杯咖啡都能治愈一个灵魂。来这里的人形形色色——失恋的上班族、迷茫的大学生、孤独的老人、追梦的年轻音乐人……每个人都在这里找到片刻的安宁。而金书妍也通过他们的故事，慢慢疗愈了自己内心的伤口。这部漫画像一杯温热的咖啡，抚慰着每一个疲惫的心灵。',
    category: '日常',
    categorySlug: 'slice-of-life',
    tags: ['治愈', '咖啡', '生活', '文学'],
    rating: 9.1,
    views: 420000,
    status: '连载中',
    totalChapters: 30,
    updateDate: '2026-08-04',
    chapters: Array.from({ length: 30 }, (_, i) => ({
      id: `comic-17-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-04',
    })),
    isNew: true,
    isHot: false,
    isRecommended: false,
  },
  {
    id: 'comic-18',
    title: '异能者联盟',
    author: '郑号锡',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20superhero%20action%20manhwa%20cover%2C%20team%20of%20young%20heroes%20with%20different%20powers%20in%20dynamic%20poses%2C%20vibrant%20energy%20effects%2C%20modern%20urban%20background%2C%20bold%20colors%2C%20clean%20illustration%2C%20exciting%20atmosphere%2C%20professional%20digital%20art&width=400&height=560&seq=comic-cover-18&orientation=portrait',
    description: '一群拥有超能力的年轻人组成团队，守护城市和平的英雄故事。',
    longDescription: '在首尔这座城市中，隐藏着一群身怀异能的人。他们中有能操控火焰的咖啡师、能读心的心理医生、能隐身的快递员、还有力大无穷的高中生。当城市面临超自然威胁时，这些看似普通的人聚集在一起，组成了异能者联盟。他们在城市暗处与邪恶势力对抗，同时也要隐藏自己的身份，过着普通人的生活。但当一个前所未有的威胁出现时，他们必须向世界揭开自己的面纱。激动人心的超能力大战，就此展开！',
    category: '动作',
    categorySlug: 'action',
    tags: ['超能力', '英雄', '团队', '都市'],
    rating: 9.2,
    views: 760000,
    status: '连载中',
    totalChapters: 52,
    updateDate: '2026-08-02',
    chapters: Array.from({ length: 52 }, (_, i) => ({
      id: `comic-18-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-02',
    })),
    isNew: false,
    isHot: false,
    isRecommended: false,
  },
  {
    id: 'comic-19',
    title: '心动警报',
    author: '金智媛',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romantic%20comedy%20manhwa%20cover%2C%20couple%20with%20surprised%20expressions%20in%20awkward%20romantic%20moment%2C%20bright%20and%20playful%20style%2C%20pink%20and%20mint%20color%20palette%2C%20clean%20illustration%2C%20lighthearted%20mood%2C%20professional%20digital%20art&width=400&height=560&seq=comic-cover-19&orientation=portrait',
    description: '欢喜冤家的爆笑恋爱攻防战，每一集都让人心跳加速。',
    longDescription: '朴敏智和姜瑞俊是公认的死对头。从小学到大学，两人不是吵架就是互相拆台。周围所有人都觉得他们不可能在一起——直到有一天，两人因为一个意外变成了邻居。朝夕相处之下，他们渐渐发现了对方不为人知的一面。朴敏智发现姜瑞俊并非表面那么冷漠，而姜瑞俊也察觉到自己对朴敏智的心意。但多年的"死对头"关系让他们谁都不敢先表白。一场令人捧腹又心动的恋爱攻防战，就此打响！',
    category: '恋爱',
    categorySlug: 'romance',
    tags: ['欢喜冤家', '恋爱', '搞笑', '甜蜜'],
    rating: 9.4,
    views: 590000,
    status: '连载中',
    totalChapters: 44,
    updateDate: '2026-08-04',
    chapters: Array.from({ length: 44 }, (_, i) => ({
      id: `comic-19-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-04',
    })),
    isNew: true,
    isHot: false,
    isRecommended: false,
  },
  {
    id: 'comic-20',
    title: '阴影之下',
    author: '孙兴慜',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20psychological%20thriller%20manhwa%20cover%2C%20shadowy%20figure%20behind%20unsuspecting%20person%2C%20dark%20and%20ominous%20atmosphere%2C%20deep%20charcoal%20and%20crimson%20accents%2C%20clean%20illustration%2C%20tense%20psychological%20mood%2C%20professional%20digital%20art&width=400&height=560&seq=comic-cover-20&orientation=portrait',
    description: '每个人都活在别人的阴影之下，一部探讨人性的心理悬疑作品。',
    longDescription: '心理医生崔贤宇的诊所里，突然出现了一位神秘的病人。这位病人声称自己能看到别人内心的"阴影"——那些被压抑的欲望和黑暗。起初崔贤宇以为这只是妄想症，但随着更多事件的发生，他开始怀疑自己是否也活在某个阴影之下。当诊所的病人接连遭遇诡异事件，崔贤宇发现这一切都指向了一个他想永远忘记的名字……每个人心中都有阴影，而这一次，阴影主动来找他了。',
    category: '悬疑',
    categorySlug: 'thriller',
    tags: ['心理', '悬疑', '黑暗', '人性'],
    rating: 9.5,
    views: 620000,
    status: '连载中',
    totalChapters: 40,
    updateDate: '2026-08-01',
    chapters: Array.from({ length: 40 }, (_, i) => ({
      id: `comic-20-ch-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: '2026-08-01',
    })),
    isNew: false,
    isHot: false,
    isRecommended: false,
  },
];

export const heroBanners = [
  {
    id: 'banner-1',
    comicId: 'comic-6',
    title: '仙界重生',
    subtitle: '一代仙帝陨落重生，逆天改命的绝世爽文',
    image: 'https://readdy.ai/api/search-image?query=Epic%20celestial%20realm%20with%20ancient%20Chinese%20style%20palaces%20on%20clouds%2C%20divine%20golden%20light%20rays%2C%20floating%20islands%2C%20majestic%20and%20ethereal%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20cinematic%20composition%2C%20high%20quality%20digital%20art%2C%20clean%20elegant%20style&width=1400&height=600&seq=hero-banner-1&orientation=landscape',
  },
  {
    id: 'banner-2',
    comicId: 'comic-1',
    title: '恋爱革命',
    subtitle: '平凡女高中生与校园男神的甜蜜恋爱故事',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20cherry%20blossom%20campus%20scene%20with%20soft%20sunlight%2C%20young%20couple%20silhouette%20under%20blooming%20trees%2C%20dreamy%20pink%20and%20white%20petals%2C%20warm%20spring%20atmosphere%2C%20cinematic%20composition%2C%20high%20quality%20digital%20art%2C%20clean%20romantic%20style&width=1400&height=600&seq=hero-banner-2&orientation=landscape',
  },
  {
    id: 'banner-3',
    comicId: 'comic-5',
    title: '搞笑一家人',
    subtitle: '一家五口的爆笑日常，笑到停不下来',
    image: 'https://readdy.ai/api/search-image?query=Bright%20and%20colorful%20Korean%20family%20home%20interior%2C%20warm%20sunlight%20streaming%20through%20windows%2C%20playful%20and%20lively%20atmosphere%2C%20cozy%20living%20room%20with%20scattered%20toys%2C%20vibrant%20yellow%20and%20orange%20color%20scheme%2C%20cinematic%20composition%2C%20high%20quality%20digital%20art&width=1400&height=600&seq=hero-banner-3&orientation=landscape',
  },
];